import { Schema } from '../schema/schema';
import { Structure } from '../structure/structure';
import { Company } from '../company/company';

export class Projects {
  Data: ProjectData[];
  Count: number;
}

export class Project {
  Id?: number;
  SUid?: string;
  Name1?: string;
  Name2?: string;
  Structure?: Structure;
  ProjectStart?: string;
  ProjectEnd?: string;
  Phase?: Phase;
  Variables?: Variable[];
  MyDocmaUid?: string;
  BPConnected? : boolean;
  textPinEnabled?: boolean;
  textPinFieldId?: string;

  constructor(init: Project = {}) {
    if (init) {
      Object.assign(this, init);
    }
  }
}

export class ProjectData extends Project {
  Schema?: Schema;
}

export class Phase {
  Id: number;
  Uid: string;
  Name: string;
  Description: string;
}

export class PhaseData {
  Id: number;
  Name: string;
}

export class Variable {
  Declaration?: Declaration;
  Company?: Company;
  Value?: string;
}

export class Declaration {
  Id: number;
}
